const styles = () => ({
  errorText: {
    color: 'red'
  }
});

export default styles;
